// Copyright (c) 2016 Deere & Company

import QuestionablePartSearchReport from '@deere/cps-it.warranty-model-factory/lib/questionable-part-search';
import t from 'tcomb';

const Report = t.list(QuestionablePartSearchReport, 'Report');

export const getDefaultState = () => new Report([]);

export default Report;



// WEBPACK FOOTER //
// ./src/reports/questionable-part-search/state/report.js